// git add .
// git commit -m "launch update"
// git push origin main

// For Dev:
// cd front-end
// npm start
// For Prod:
// cd front-end
// npm run build
// cd tailoredstories / cd ..
// NODE_ENV=production firebase deploy

import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ContactPage from "./pages/contact";
import HomePage from "./pages/home";
import PrintsPage from "./pages/prints";
import PrintDetailPage from "./pages/printDetailPage";
import ZinePage from "./pages/zine";
import CartPage from "./pages/cart";
import Navbar from "./components/navbar";
import OrderConfirmationPage from "./pages/orderConfirmation";
import ZineOrderConfirmationPage from "./pages/zineOrderConfirmation";

function App() {
  // const [cartItems, setCartItems] = useState([]);
  // useEffect(() => {
  //   const savedCartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
  //   console.log("Loaded cart items from localStorage:", savedCartItems);
  //   setCartItems(savedCartItems);
  // }, []);

  // // Save cart items to localStorage whenever they change
  // useEffect(() => {
  //   console.log("Saving cart items to localStorage:", cartItems);
  //   localStorage.setItem("cartItems", JSON.stringify(cartItems));
  // }, [cartItems]);
  const [cartItems, setCartItems] = useState(() => {
    const savedCartItems = localStorage.getItem("cartItems");
    return savedCartItems ? JSON.parse(savedCartItems) : [];
  });

  // Ref to prevent overwriting localStorage on initial load
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return; // Skip saving on initial load
    }

    console.log("Saving cart items to localStorage:", cartItems);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  // const addToCart = (item) => setCartItems([...cartItems, item]);
  const addToCart = (item) => {
    setCartItems((prevCartItems) => {
      // Check if an item with the same ID, size, and variation already exists
      const existingItemIndex = prevCartItems.findIndex(
        (cartItem) =>
          cartItem.selectedProduct.id === item.selectedProduct.id &&
          cartItem.selectedSize === item.selectedSize &&
          cartItem.selectedVariation === item.selectedVariation
      );

      if (existingItemIndex !== -1) {
        // If the item exists, create a new array with updated quantity
        const updatedCartItems = [...prevCartItems];
        updatedCartItems[existingItemIndex] = {
          ...updatedCartItems[existingItemIndex],
          quantity:
            updatedCartItems[existingItemIndex].quantity + item.quantity,
        };
        return updatedCartItems;
      }

      // If the item does not exist, add it to the cart
      return [...prevCartItems, item];
    });
  };
  const removeFromCart = (removedItem) => {
    console.log(removedItem);
    console.log(cartItems);
    setCartItems(
      cartItems.filter(
        (item) =>
          !(
            item.selectedProduct.id === removedItem.selectedProduct.id &&
            item.selectedSize === removedItem.selectedSize &&
            item.selectedVariation === removedItem.selectedVariation
          )
      )
    );
  };

  return (
    <Router>
      <Navbar cartItems={cartItems} />
      <Routes>
        <Route exact path="/" element={<HomePage showSection={"weddings"} />} />
        <Route
          exact
          path="/events"
          element={<HomePage showSection={"events"} />}
        />
        <Route
          exact
          path="/portraits"
          element={<HomePage showSection={"portraits"} />}
        />
        <Route
          exact
          path="/catalogue"
          element={<HomePage showSection={"catalogue"} />}
        />
        <Route exact path="/prints" element={<PrintsPage />} />
        <Route exact path="/zine" element={<ZinePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route
          path="/prints/:slug"
          element={
            <PrintDetailPage addToCart={addToCart} cartItems={cartItems} />
          }
        />
        <Route
          exact
          path="/order-confirmation"
          element={<OrderConfirmationPage setCartItems={setCartItems} />}
        />
        <Route
          exact
          path="/order-confirmation-zine"
          element={<ZineOrderConfirmationPage />}
        />
        <Route
          path="/cart"
          element={
            <CartPage
              setCartItems={setCartItems}
              cartItems={cartItems}
              removeFromCart={removeFromCart}
            />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
